import { put, call, takeLatest, select } from 'redux-saga/effects';
import { GET_GPS_DEVICE_REQUEST, getGpsDeviceSuccess, getGpsDeviceFailure } from '../actions/gps_devices';
import { getGpsDevices } from '../services/gps_devices';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';

export const getGpsDeviceWorker = function* ({ payload: { filters = {} } = {} } = {}) {
    try {
        const token = yield select(accessTokenSelector);

        const {
            data: { gps_devices }
        } = yield call(getGpsDevices, filters, token);

        yield put(getGpsDeviceSuccess(gps_devices[0] || {}));
    } catch (err) {
        yield put(getGpsDeviceFailure(err));
        yield put(showGlobalError(true, err));
    }
};

export default [takeLatest(GET_GPS_DEVICE_REQUEST, getGpsDeviceWorker)];
